export const SELECT_BASIC_PLAN = 'SELECT_BASIC_PLAN'
export const selectBasicPlan = (product) => ({
  type: SELECT_BASIC_PLAN,
  payload: product,
})
